import * as React from 'react';
import Basic from '../_layout';
import generator from '../_layout/util';

const Layout = generator({
  prefixCls: 'mkui-layout-detail',
})(Basic);
const Header = generator({
  prefixCls: 'mkui-layout-detail-header',
})(Basic);
const Title = generator({
  prefixCls: 'mkui-layout-detail-header-title',
})(Basic);
const Content = generator({
  prefixCls: 'mkui-layout-detail-content',
})(Basic);
const Footer = generator({
  prefixCls: 'mkui-layout-detail-footer',
})(Basic);
const Operates = generator({
  prefixCls: 'mkui-layout-detail-header-operates',
})(Basic);
Header.Title = Title;
Header.Operates = Operates;
Layout.Header = Header;
Layout.Content = Content;
Layout.Footer = Footer;
export default Layout;
